import cropr from "../shared/utils/cropr";
import gettext from "../shared/utils/gettext";

const searchKitTranslations = {
  "reset.clear_all": gettext("Clear All Filters"),
  "facets.view_more": gettext("View more"),
  "facets.view_less": gettext("View less"),
  "facets.view_all": gettext("View all"),
  "NoHits.NoResultsFound": gettext("No results found."),
  "hitstats.results_found": gettext("{hitCount} results found"),
  "pagination.previous": gettext(" Previous"),
  "pagination.next": gettext("Next"),
  "searchbox.placeholder": gettext("Search"),
};

const CFTranslateFunction = (key) => {
  if (searchKitTranslations[key]) {
    return searchKitTranslations[key];
  }
  const type = cropr.isobus_measurement_types[key];
  if (type) {
    return `${type.name} ${type.unit ? `(${type.unit})` : ""}`;
  }
  if (cropr.data_set_metas[key]) {
    return cropr.data_set_metas[key].name;
  }
  if (cropr.getDeviceName(key) !== key) {
    return cropr.getDeviceName(key);
  }
  const cf = cropr.cropfields.findWhere({ did: key });
  if (cf) {
    return cf.get("name");
  }
};

export default CFTranslateFunction;
